import { Loader2 } from "lucide-react";

import AthleteDashboard from "./AthleteDashboard";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "./ui/dialog";

/**
 * La finestra «vista atleta»: la dashboard dell'atleta (`AthleteDashboard` in
 * `previewState`) dentro una cornice da telefono, per il coach.
 *
 * Una sola finestra per due ingressi: la scheda Atleti (un atleta, coi suoi
 * dati: sandbox con `athleteId`) e il blocco «Oggi» della dashboard coach (un
 * programma, in sola lettura: senza `athleteId`). Sul telefono la cornice si
 * toglie, lo schermo e' gia' un telefono.
 */
export default function AthleteViewPreview({
	open,
	onOpenChange,
	title,
	description = null,
	aside = null,
	headerActions = null,
	previewState = null,
	loading = false,
	emptyLabel = "",
}) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="bg-card border-border w-[calc(100vw-1rem)] sm:w-[calc(100vw-2rem)] max-w-5xl max-h-[92vh] overflow-hidden p-4 sm:p-6">
				<DialogHeader className="pt-3 md:pt-0 pr-6">
					<DialogTitle className="font-heading break-words">{title}</DialogTitle>
					<DialogDescription className={description ? "" : "hidden"}>
						{description}
					</DialogDescription>
					{headerActions}
				</DialogHeader>

				<div className="grid grid-cols-1 lg:grid-cols-[260px_minmax(0,1fr)] gap-4 h-full min-h-0">
					{aside ? (
						<div className="space-y-3 min-w-0 lg:max-w-[260px] hidden md:block">
							{aside}
						</div>
					) : null}

					<div
						className={`mx-auto w-full md:w-[390px] max-w-full md:rounded-[28px] md:border md:border-border md:bg-black md:p-2 md:shadow-2xl md:shadow-black/60 ${
							aside ? "" : "lg:col-span-2"
						}`}
					>
						{/* overflow-x-hidden: una fila che sborda non deve far
						    scorrere di lato tutto il telefono. */}
						<div className="rounded-sm md:rounded-[22px] border border-border bg-background h-[72vh] overflow-y-auto overflow-x-hidden">
							{loading ? (
								<div className="h-full flex items-center justify-center">
									<Loader2 className="w-6 h-6 animate-spin text-volt" />
								</div>
							) : previewState?.program ? (
								// px-4, non meno: le file a scorrimento della dashboard
								// (programmi, settimane, giorni) escono di `-mx-4` per
								// arrivare al bordo, e con un margine piu' stretto
								// sbordano.
								<AthleteDashboard
									previewState={previewState}
									containerClassName="max-w-none mx-0 px-4 pb-6"
								/>
							) : (
								<div className="h-full flex items-center justify-center px-6 text-center text-sm text-muted-foreground">
									{emptyLabel}
								</div>
							)}
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
